export const URI = {
  LIST_OBJECTS: 'listObjects',
  UPLOAD_OBJECTS: 'uploadObjects',
  UPLOAD_OBJECT: 'uploadObject',
};
